import { Box, Divider, Flex, Icon, SimpleGrid, Text, useColorModeValue } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { IconType } from 'react-icons';
import { typography } from '../../theme/tokens';

interface FormSectionProps {
	label?: string;
	icon?: IconType;
	columns?: number | { base?: number; md?: number; lg?: number };
	children: ReactNode;
}

/**
 * Groups related form fields with an optional icon + label + extending divider line.
 * Per DESIGN.md form section pattern.
 */
export default function FormSection({ label, icon, columns = 1, children }: FormSectionProps) {
	const iconColor = useColorModeValue('brand.500', 'brand.400');
	const labelColor = useColorModeValue('secondaryGray.600', 'secondaryGray.500');
	const dividerColor = useColorModeValue('secondaryGray.100', 'whiteAlpha.100');

	return (
		<Box>
			{label && (
				<Flex align='center' gap='10px' mb='16px'>
					{icon && (
						<Icon as={icon} w='16px' h='16px' color={iconColor} flexShrink={0} />
					)}
					<Text
						{...typography.formSectionLabel}
						color={labelColor}
					>
						{label}
					</Text>
					<Divider borderColor={dividerColor} flex={1} />
				</Flex>
			)}
			<SimpleGrid
				columns={typeof columns === 'number' ? columns : columns}
				spacing='20px'
			>
				{children}
			</SimpleGrid>
		</Box>
	);
}
